module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-pop",
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "loading-box"
  }, [_c('div', {
    staticClass: "load-effect"
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-tip"
  }, [_vm._t("default", [_vm._v("\n\t\t\t\t加载中\n\t\t\t")])], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3e62e7ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e62e7ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/pages/compontents/loadingModel.vue
// module id = 418
// module chunks = 32